import { useCancelRequestHook } from '@op/hooks/useCancelRequest';
import { getGameStoreRelativeDetails } from '@op/services';
import { useEffect, useState } from 'react';

interface RelativeDetails {
  edition_unified_id: string;
  entity_type: string;
  channels: string[];
  id_type: string;
}

export function useGetRelativeDetails({
  filter,
  formatData,
  extraData,
}: {
  filter: any;
  formatData?: any;
  extraData?: any;
}) {
  const [relativeDetails, setRelativeDetails] =
    useState<RelativeDetails | null>(null);
  const [error, setError] = useState(false);
  const { loading, wrapperRequest } = useCancelRequestHook();
  function requestRelativeDetails() {
    if (!filter?.edition_unified_id) return;
    setError(false);
    wrapperRequest((cancelFunc) =>
      getGameStoreRelativeDetails(filter, cancelFunc)
        .then((data: any) => {
          const formatRecords = formatData?.(data, filter) || data;
          const { list } = formatRecords;
          const result = list.reduce(
            (acc, current) => {
              if (current.entity_type === filter.entity_type) {
                acc.channels = current.channels;
              } else {
                acc.details = {
                  ...current,
                  channels: current.channels.filter(
                    (channel) => !acc.channels.includes(channel),
                  ),
                };
              }
              return acc;
            },
            { channels: [], details: {} },
          );
          if (result.details?.channels?.length) {
            setRelativeDetails(result.details);
          }
        })
        .catch(() => {
          setError(true);
        }),
    );
  }

  useEffect(() => {
    requestRelativeDetails();
  }, [filter]);

  return {
    data: relativeDetails,
    loading,
    error,
    refetch: useGetRelativeDetails,
  };
}
